// 9fbef606107a605d69c0edbcd8029e5d
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import withStyles from '@tcp/core/src/components/common/hoc/withStyles';
import { shortFormattedDate, isDateToday, getDateObject } from '@tcp/core/src/utils/utils';
import { getShortDate, getViewportInfo } from '@tcp/core/src/utils';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import CollapsibleContainer from '@tcp/core/src/components/common/molecules/CollapsibleContainer/views/CollapsibleContainer.view';
import style, { collapsibleOverrideStyles } from '../styles/StoreHours.style';
import SpecialHours from '../../../atoms/StoreHours/views/SpecialHours.jsx';
import {
  STORE_DETAILS_LABELS,
  StoreLocatorLabels,
  lblStoredetailsSpecialHoursTextHolidayHours,
  lblStoredetailsSpecialHoursTextOpen,
  lblStoreldetailsClosed,
} from '../../../../features/storeLocator/Labels/StoreLocator.labels.js';
import {
  getDynamicLabelValues,
  getLabelFromCopyOrFromTranslation,
  renderLabel,
} from '../../../../../utils/labels/labelUtilty.js';
import errorBoundary from '../../../hoc/withErrorBoundary';

// Override collapsible container
const StoreCollapsible = withStyles(CollapsibleContainer, collapsibleOverrideStyles);

class StoreHours extends PureComponent {
  static getListItems(data, storeHolidays, isStoreDetailsDesktopRedesignEnabled) {
    if (storeHolidays) {
      data?.forEach((item) => {
        const newStr = item?.fromHour?.split(' ')[0].replace(/[,-]/g, '/');
        const date = getDateObject(newStr);
        // eslint-disable-next-line no-param-reassign
        item.datelabel = `${date?.toLocaleString('default', {
          month: 'long',
        })} ${date?.getDate()}`;
      });
    }
    return data.map((item) => (
      <li
        key={item.id}
        className={`dsk-col ${isDateToday(item.fromHour) && !storeHolidays ? 'current-date' : ''} `}
      >
        {isStoreDetailsDesktopRedesignEnabled ? (
          this.getFormattedlistItem(item)
        ) : (
          <div className="text-left">{item.label}</div>
        )}
        {this.getStoreHours(item, isStoreDetailsDesktopRedesignEnabled, storeHolidays)}
      </li>
    ));
  }

  static getMultipleEntry = (item, storeHolidays) => {
    return (
      Array.isArray(item.value) &&
      item.value.length > 0 &&
      item.value.map((timeArr) => (
        <>
          <div className="text-right" key={`${item.id}-${timeArr}`}>
            {timeArr}
          </div>
          {storeHolidays && item.label ? (
            <div className="header-text-body">{item.label}</div>
          ) : null}
        </>
      ))
    );
  };

  static headerTextStatus = (isClosed, data, isStoreClosedForWholeWeek, nextOpenDay) => {
    if (isClosed) {
      return (
        <div>
          <span className="header-text-status-closed" isClosed>
            {renderLabel(this.storeDetailLabels?.lbl_storeldetails_closed, lblStoreldetailsClosed)}
          </span>
          {!isStoreClosedForWholeWeek ? (
            <>
              <span className="header-text-secondary-status">{`${renderLabel(
                getDynamicLabelValues('dynamic.browse_d.lbl_store_detail_store_hours_opens'),
                'lbl_store_detail_store_hours_opens'
              )}`}</span>
              {nextOpenDay ? (
                <span className="header-text-secondary-status">
                  {` ${getShortDate(nextOpenDay?.label)}, `}
                </span>
              ) : null}
              <span className="header-text-secondary-status">{data?.value[0]?.split('-')[0]}</span>
            </>
          ) : null}
        </div>
      );
    }
    return (
      <div>
        <span className="header-text-status-open">
          {renderLabel(
            this.storeDetailLabels?.lbl_storedetails_specialHoursText_open,
            lblStoredetailsSpecialHoursTextOpen
          )}
        </span>
        <span className="header-text-secondary-status">
          {`${renderLabel(
            getDynamicLabelValues('dynamic.browse_d.lbl_store_detail_store_hours_closes'),
            'lbl_store_detail_store_hours_closes'
          )} ${data?.value[0]?.split('-')[1]}`}
        </span>
      </div>
    );
  };

  static getCollapsibleTitle(
    title,
    isStoreDetailsDesktopRedesignEnabled,
    data,
    isStoreClosedForWholeWeek,
    nextOpenDay
  ) {
    return isStoreDetailsDesktopRedesignEnabled ? (
      <>
        <div className="collapsible-header-text">{title}</div>
        {title !==
        renderLabel(
          this.storeDetailLabels?.lbl_storedetails_specialHoursText_holiday_hours,
          lblStoredetailsSpecialHoursTextHolidayHours
        ) ? (
          this.headerTextStatus(data?.isClosed, data, isStoreClosedForWholeWeek, nextOpenDay)
        ) : (
          <div className="holiday-hours-header-wrapper">
            <span className="header-text-status">
              {shortFormattedDate(data?.fromHour)?.split(',')[1]}
            </span>
            {data?.isClosed ? (
              <div className="holiday-hrs-header">
                <div className="header-text-status">
                  {renderLabel(
                    this.storeDetailLabels?.lbl_storeldetails_closed,
                    lblStoreldetailsClosed
                  )}
                </div>
                <div className="holiday-hrs-secondary-status">{data?.label}</div>
              </div>
            ) : (
              <div>
                <span className="header-text-secondary-status">{data?.value?.[0]}</span>
                {data?.label ? (
                  <div className="holiday-hrs-secondary-status">{data?.label}</div>
                ) : null}
              </div>
            )}
          </div>
        )}
      </>
    ) : (
      <BodyCopy
        className="collapsible-header-text"
        fontSize="fs12"
        component="span"
        fontWeight="extrabold"
        color="text.primary"
        fontFamily="secondary"
      >
        {title}
      </BodyCopy>
    );
  }

  static getFormattedlistItem = (item) => {
    const formattedDate = shortFormattedDate(item?.fromHour);
    return item?.datelabel ? (
      <div className={item?.isClosed ? 'item-date-holiday-hrs' : 'item-date'}>
        {formattedDate?.split(',')[1]}
      </div>
    ) : (
      <>
        <div className="item-text">{formattedDate?.split(',')[0]}</div>
        <div className="item-date">{formattedDate?.split(',')[1]}</div>
      </>
    );
  };

  static getStoreHours = (item, isStoreDetailsDesktopRedesignEnabled, storeHolidays) => {
    if (isStoreDetailsDesktopRedesignEnabled && storeHolidays && item?.isClosed) {
      return (
        <div className="holiday-hrs-header">
          <div className="header-text-status-body">
            {renderLabel(this.storeDetailLabels?.lbl_storeldetails_closed, lblStoreldetailsClosed)}
          </div>
          <div className="header-text-body">{item?.label}</div>
        </div>
      );
    }
    if (item.isClosed) {
      return (
        <div className="text-right" key={`${item.id}-Closed`}>
          {renderLabel(this.storeDetailLabels?.lbl_storeldetails_closed, lblStoreldetailsClosed)}
        </div>
      );
    }
    return !Array.isArray(item.value) ? (
      <div>
        <div className="text-right">{item.value}</div>
        {storeHolidays && item.label ? <div className="header-text-body">{item.label}</div> : null}
      </div>
    ) : (
      <div>{this.getMultipleEntry(item, storeHolidays)}</div>
    );
  };

  static getListData(data, storeHolidays, isStoreDetailsDesktopRedesignEnabled) {
    const newDesignCls = isStoreDetailsDesktopRedesignEnabled ? 'data-list-wrapper-new' : '';
    return (
      <div className={`data-list-wrapper ${newDesignCls}`}>
        <ul className="data-list">
          {this.getListItems(data, storeHolidays, isStoreDetailsDesktopRedesignEnabled)}
        </ul>
      </div>
    );
  }

  constructor(props) {
    super(props);
    this.state = {
      isStoreHrsOpen: true,
    };
    this.toggleExpandedState = this.toggleExpandedState.bind(this);
  }

  static storeDetailLabels = getLabelFromCopyOrFromTranslation(
    STORE_DETAILS_LABELS,
    StoreLocatorLabels
  );

  toggleExpandedState() {
    this.setState((prevState) => ({
      isStoreHrsOpen: !prevState.isStoreHrsOpen,
    }));
  }

  headerRow(formattedCurrentStoreHolidayHours) {
    if (formattedCurrentStoreHolidayHours && Array.isArray(formattedCurrentStoreHolidayHours)) {
      return formattedCurrentStoreHolidayHours?.[0];
    }
    return null;
  }

  formattedHolidayhrs(formattedCurrentStoreHolidayHours) {
    if (formattedCurrentStoreHolidayHours && Array.isArray(formattedCurrentStoreHolidayHours)) {
      const formattedHolidayhours = [...formattedCurrentStoreHolidayHours];
      formattedHolidayhours?.splice(0, 1);
      return formattedHolidayhours;
    }
    return [];
  }

  getIsStoreClosedForWholeWeek(storeTiming) {
    if (Array.isArray(storeTiming) && storeTiming.length) {
      return !storeTiming.find((day) => !day.isClosed);
    }
    return true;
  }

  /**
   * Determines the next open day from a list of store timings.
   *
   * This function takes an array of store timing objects and returns the next day
   * that the store is open, after checking if the current day and tomorrow are closed.
   *
   * @param {Array<Object>} storeTiming - An array of objects representing store timings.
   * Each object should have an `isClosed` property indicating whether the store is closed on that day.
   * The array should be ordered with the current day as the first element, followed by tomorrow, and so on.
   *
   * @returns {Object|null} - Returns the first day object from the array where the store is open,
   * or `null` if the current day or tomorrow is not closed, or if no open day is found.
   */
  getNextOpenDay(storeTiming) {
    if (Array.isArray(storeTiming) && storeTiming.length) {
      const [currentDay, tomorrow, ...nextOpenDays] = storeTiming;
      if (currentDay.isClosed && tomorrow.isClosed) {
        return nextOpenDays.find((day) => !day.isClosed);
      }
      return null;
    }
    return null;
  }

  render() {
    const {
      className,
      children,
      title,
      storeMeta,
      isStoreHoursWebEnabled,
      storeTiming,
      currentStoreHolidayHours,
      specialHoursNumberOfDaysCount,
      isStoreDetailsDesktopRedesignEnabled,
      formattedCurrentStoreHolidayHours,
      isStoreDetailsRedesignMobileEnabled,
      ...rest
    } = this.props;
    const isMobile = getViewportInfo()?.isMobile;
    const { isStoreHrsOpen } = this.state;

    const headerItem = this.headerRow(formattedCurrentStoreHolidayHours);

    const formattedHolidayhours = this.formattedHolidayhrs(formattedCurrentStoreHolidayHours);
    const isStoreClosedForWholeWeek = this.getIsStoreClosedForWholeWeek(storeTiming);
    const nextOpenDay = this.getNextOpenDay(storeTiming);
    return !isStoreDetailsDesktopRedesignEnabled ? (
      <div className={className}>
        <div className={className}>
          {isStoreHoursWebEnabled && currentStoreHolidayHours?.length ? (
            <SpecialHours
              storeTiming={currentStoreHolidayHours}
              fromDate={storeTiming?.[0]?.fromHour}
              toDateDayCount={specialHoursNumberOfDaysCount}
            />
          ) : null}
          {isStoreDetailsRedesignMobileEnabled && storeMeta.length > 0 && (
            <div className="meta">{this.constructor.getListData(storeMeta)}</div>
          )}
        </div>
        <div className={isStoreDetailsRedesignMobileEnabled && 'store-hours-wrapper'}>
          {storeTiming.length > 0 && (
            <StoreCollapsible
              {...rest}
              header={this.constructor.getCollapsibleTitle(
                title,
                isStoreDetailsRedesignMobileEnabled,
                storeTiming[0],
                isStoreClosedForWholeWeek,
                nextOpenDay
              )}
              body={this.constructor.getListData(
                storeTiming,

                false,
                isStoreDetailsRedesignMobileEnabled
              )}
              isStoreDetailsRedesignMobileEnabled={isStoreDetailsRedesignMobileEnabled}
              defaultOpen={isStoreHrsOpen}
              toggleExpandedState={this.toggleExpandedState}
            />
          )}

          {isStoreDetailsRedesignMobileEnabled && formattedCurrentStoreHolidayHours?.length > 0 && (
            <StoreCollapsible
              {...rest}
              header={this.constructor.getCollapsibleTitle(
                renderLabel(
                  StoreHours.storeDetailLabels?.lbl_storedetails_specialHoursText_holiday_hours,
                  lblStoredetailsSpecialHoursTextHolidayHours
                ),
                isStoreDetailsRedesignMobileEnabled,
                headerItem
              )}
              body={this.constructor.getListData(
                formattedHolidayhours,

                true,
                isStoreDetailsRedesignMobileEnabled
              )}
              isStoreDetailsRedesignMobileEnabled={isStoreDetailsRedesignMobileEnabled}
              isHolidayHours
              defaultOpen={!isStoreHrsOpen}
              toggleExpandedState={this.toggleExpandedState}
            />
          )}
        </div>
        {!isStoreDetailsRedesignMobileEnabled && storeMeta.length > 0 && (
          <div className="meta">{this.constructor.getListData(storeMeta)}</div>
        )}
        {children}
      </div>
    ) : (
      <>
        <div className={className}>
          {isStoreHoursWebEnabled && currentStoreHolidayHours?.length ? (
            <SpecialHours
              storeTiming={currentStoreHolidayHours}
              fromDate={storeTiming?.[0]?.fromHour}
              toDateDayCount={specialHoursNumberOfDaysCount}
            />
          ) : null}
          {storeMeta.length > 0 && (
            <div className="meta">{this.constructor.getListData(storeMeta)}</div>
          )}
        </div>
        {storeTiming.length > 0 && (
          <StoreCollapsible
            {...rest}
            header={this.constructor.getCollapsibleTitle(
              title,
              isStoreDetailsDesktopRedesignEnabled,
              storeTiming[0],
              isStoreClosedForWholeWeek,
              nextOpenDay
            )}
            body={this.constructor.getListData(
              storeTiming,
              false,
              isStoreDetailsDesktopRedesignEnabled
            )}
            isStoreDetailsDesktopRedesignEnabled={isStoreDetailsDesktopRedesignEnabled}
            isCollapseDisabled={!isMobile}
          />
        )}
        {formattedCurrentStoreHolidayHours?.length > 0 && (
          <StoreCollapsible
            {...rest}
            header={this.constructor.getCollapsibleTitle(
              renderLabel(
                StoreHours.storeDetailLabels?.lbl_storedetails_specialHoursText_holiday_hours,
                lblStoredetailsSpecialHoursTextHolidayHours
              ),
              isStoreDetailsDesktopRedesignEnabled,
              headerItem
            )}
            body={this.constructor.getListData(
              formattedHolidayhours,
              true,
              isStoreDetailsDesktopRedesignEnabled
            )}
            isStoreDetailsDesktopRedesignEnabled={isStoreDetailsDesktopRedesignEnabled}
            isCollapseDisabled={!isMobile}
            isHolidayHours
          />
        )}
        {children}
      </>
    );
  }
}

StoreHours.propTypes = {
  className: PropTypes.string.isRequired,
  children: PropTypes.arrayOf(PropTypes.node),
  title: PropTypes.string.isRequired,
  storeMeta: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      label: PropTypes.string,
      value: PropTypes.string,
    })
  ),
  storeTiming: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      label: PropTypes.string,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.shape([])]),
    })
  ),
};

StoreHours.defaultProps = {
  children: null,
  storeMeta: [],
  storeTiming: [],
};

export default errorBoundary(withStyles(StoreHours, style));
